(function (app, ng) {

    var taskDateStructure = {
        DueDate: "date"
    };

    function datify(obj, structure) {
        if (!obj) return;
        if (ng.isArray(structure)) {
            for (let i = 0; i < obj.length; i++) {
                if (structure[0] === "date" && ng.isString(obj[i]))
                    obj[i] = new Date(obj[i]);
                if (ng.isObject(structure[0]) || ng.isArray(structure[0]))
                    datify(obj[i], structure[0]);
            }
            return;
        }
        if (ng.isObject(structure)) {
            for (let key in structure) {
                if (!structure.hasOwnProperty(key)) continue;
                if (structure[key] === "date" && ng.isString(obj[key]))
                    obj[key] = new Date(obj[key]);
                if (ng.isObject(structure[key]) || ng.isArray(structure[key]))
                    datify(obj[key], structure[key]);
            }
        }
    }

    app.provider("scheduledTaskApi",
        [
            function() {
                this.$get = (crmApiGateway) => {
                    const service = {
                        getScheduledTask: (taskId) => {
                            return crmApiGateway.get(`/ScheduledTasks/${taskId}`).then(response => {
                                datify(response, taskDateStructure);
                                return response;
                            });
                        },
 
                        getUserScheduledTasks: (userId, year, month) => {
                            let url = `/Users/${userId}/ScheduledTasks?`;

                            if (!!year && !!month) {
                                url = `${url}&year=${year}&month=${month}`;
                            }

                            return crmApiGateway.getArray(url).then(tasks => {
                                tasks.forEach(task => datify(task, taskDateStructure));
                                return tasks;
                            });
                        },
                        getUserIncompleteTasks: (userId) => {
                            let url = `/Users/${userId}/ScheduledTasks/Incomplete?`;

                            return crmApiGateway.getArray(url).then(tasks => {
                                tasks.forEach(task => datify(task, taskDateStructure));
                                return tasks;
                            });
                        },
                        getClientIncompleteTasks: (clientId) => {
                            let url = `/Clients/${clientId}/ScheduledTasks/Incomplete?`;

                            return crmApiGateway.getArray(url).then(tasks => {
                                tasks.forEach(task => datify(task, taskDateStructure));
                                return tasks;
                            });
                        },
                        getScheduledTaskNotes: (taskId) => {
                            return crmApiGateway.getArray(`/ScheduledTasks/${taskId}/Notes`);
                        },
                        addScheduledTask: (task) => {
                            return crmApiGateway.post("/ScheduledTasks", task);
                        },
                        addScheduledTaskNote: (taskId, note) => {
                            return crmApiGateway.post(`/ScheduledTasks/${taskId}/Notes`, note);
                        },
                        updateScheduledTask: (taskId, task) => {
                            return crmApiGateway.put(`/ScheduledTasks/${taskId}`, task);
                        },
                        completeScheduledTask: (taskId) => {
                            return crmApiGateway.put(`/ScheduledTasks/${taskId}/Complete`);
                        },
                        updateScheduledTaskNote: (taskId, noteId, note) => {
                            return crmApiGateway.put(`ScheduledTasks/${taskId}/Notes/${noteId}`, note);
                        },
                        deleteScheduledTask: (taskId) => {
                            return crmApiGateway.delete(`/ScheduledTasks/${taskId}`);
                        },
                        removeScheduledTaskNote: (taskId, noteId) => {
                            return crmApiGateway.delete(`/ScheduledTasks/${taskId}/Notes/${noteId}`);
                        }
                    }

                    return service;
                }
            }
        ]);

})(window.app, window.angular);